module.exports = __webpack_public_path__ + "img/sincechild-title-md.fb5d9bba.png";